export enum InvoiceStatusEnum {
  INIT = 'INIT',
  CANCELED = 'CANCELED',
  ISSUED = 'ISSUED',
  OFFLINE = 'OFFLINE',
  ACCEPTED = 'ACCEPTED',
  PAID = 'PAID',
  BILLED = 'BILLED',
  LATE = 'LATE',
}
